import i18n from "../translations";
import {
  Conversation,
  ConversationMessage,
  ConversationMessageType,
} from "../types";

export default class ConversationHelper {
  static getName(conversation: Conversation) {
    if (conversation.assignee) {
      return conversation.assignee.name || conversation.assignee.email;
    }

    return "";
  }

  static getLastMessageMetadata(
    conversation: Conversation,
    admin: boolean = false
  ): { message: ConversationMessage; description: string } | null {
    let messages = admin
      ? conversation.messages
      : conversation.messages.filter((message) => {
          return ![ConversationMessageType.NOTE].includes(message.type);
        });

    const lastMessage = messages[messages.length - 1];

    if (!lastMessage) return null;

    let description: string = "";

    switch (lastMessage.type) {
      case ConversationMessageType.REQUEST_EMAIL:
        description = i18n.t("ConversationHelper::sent an email request");
        break;
      case ConversationMessageType.TEXT:
        description = lastMessage.content;
        break;
      case ConversationMessageType.NOTE:
        description = lastMessage.content;
        break;
      case ConversationMessageType.ATTACHMENT:
      case ConversationMessageType.GIF:
        description = i18n.t("ConversationHelper::sent an image");
        break;
      case ConversationMessageType.ARTICLE:
        description = i18n.t("ConversationHelper::sent an article");
        break;
      case ConversationMessageType.TYPING:
        description = i18n.t("ConversationHelper::typing...");
      default:
        throw new Error(
          `[ConversationHelper] unknown type ${lastMessage.type}`
        );
    }

    return {
      message: lastMessage,
      description: description,
    };
  }
}
